import { useState } from 'react';

import { Milestone } from '../../../../apollo/__generated__/graphql';
import { useEventQuery } from '../../../../event/hooks/useEventQuery';
import { useMilestonesQuery } from '../../../../event/hooks/useMilestonesQuery';
import { useDeleteMilestoneMutation } from '../../../hooks/useDeleteMilestoneMutation';

export const useMilestonesDrawer = (eventId: string | null) => {
  const [milestoneToDeleteId, setMilestoneToDeleteId] = useState<string | null>(
    null,
  );
  const [isCreateMilestoneDrawerOpen, setIsCreateMilestoneDrawerOpen] =
    useState<boolean>(false);
  const [editingMilestone, setEditingMilestone] = useState<Milestone | null>(
    null,
  );
  const { data, loading } = useMilestonesQuery(eventId);
  const { data: eventData } = useEventQuery(eventId);

  const onShowDeleteDialog = (milestoneId: string) => {
    setMilestoneToDeleteId(milestoneId);
  };
  const onCloseDeleteDialog = () => {
    setMilestoneToDeleteId(null);
  };

  const { deleteMilestone } = useDeleteMilestoneMutation(onCloseDeleteDialog);

  const onCreateMilestone = () => {
    setIsCreateMilestoneDrawerOpen(true);
  };

  const onCreateMilestoneDrawerClose = () => {
    setIsCreateMilestoneDrawerOpen(false);
  };

  const onDeleteMilestone = () => {
    if (milestoneToDeleteId) {
      deleteMilestone(milestoneToDeleteId);
    }
  };

  const onEditMilestoneDrawerClose = () => {
    setEditingMilestone(null);
  };

  const onShowEditDialog = (milestone: Milestone) => {
    setEditingMilestone(milestone);
  };

  const milestones = data?.milestones ?? [];
  return {
    milestones,
    isCreateMilestoneDrawerOpen,
    onCreateMilestone,
    onCreateMilestoneDrawerClose,
    loading,
    onShowDeleteDialog,
    onDeleteMilestone,
    onCloseDeleteDialog,
    milestoneToDeleteId,
    event: eventData?.event,
    editingMilestone,
    onEditMilestoneDrawerClose,
    onShowEditDialog,
  };
};
